import { FecImportConfirmationKind } from '../enums/fecImportConfirmationKind'
import type { FecImportItem } from '../query-api'
import { getFecImportAnalysisErrorTranslation } from './getFecImportAnalysisErrorTranslation'

const NETWORK_ERROR_TITLE_KEY =
  'settings.organization.accounting.fec_file_import.modal.confirmation_step.network_error_title'
const NETWORK_ERROR_MESSAGE_KEY =
  'settings.organization.accounting.fec_file_import.modal.confirmation_step.network_error_message'
const TIMEOUT_TITLE_KEY = 'settings.organization.accounting.fec_file_import.modal.confirmation_step.timeout_title'
const TIMEOUT_MESSAGE_KEY = 'settings.organization.accounting.fec_file_import.modal.confirmation_step.timeout_message'

interface GetFecImportConfirmationErrorCopyParams {
  confirmationKind: FecImportConfirmationKind
  failedFecImports: FecImportItem[]
  fecImports: FecImportItem[]
}

export const getFecImportConfirmationErrorCopy = ({
  confirmationKind,
  failedFecImports,
  fecImports,
}: GetFecImportConfirmationErrorCopyParams) => {
  if (confirmationKind === 'network') {
    return { messageKey: NETWORK_ERROR_MESSAGE_KEY, titleKey: NETWORK_ERROR_TITLE_KEY }
  }

  if (confirmationKind === 'timeout') {
    return { messageKey: TIMEOUT_MESSAGE_KEY, titleKey: TIMEOUT_TITLE_KEY }
  }

  return {
    messageKey: undefined,
    titleKey: getFecImportAnalysisErrorTranslation(failedFecImports[0] || fecImports[0]).titleKey,
  }
}
